module.exports = __webpack_public_path__ + "static/media/Maf_ART.5a39329e.jpg";